// W-0821 — Schemas Yup da página Transferir Títulos para Cobrança.
// LICOES §1.6 — required + format + min/max + .test() para regra de negócio.

import * as Yup from 'yup';

export const filtrosSchema = Yup.object().shape({
  diasMinimoVencidos: Yup.number()
    .typeError('Informe um número')
    .required('Informe os dias mínimos vencidos')
    .integer('Use valor inteiro')
    .min(0, 'Não pode ser negativo'),
  diasMaximoVencidos: Yup.number()
    .typeError('Informe um número')
    .required('Informe os dias máximos vencidos')
    .integer('Use valor inteiro')
    .min(0, 'Não pode ser negativo')
    .test(
      'range-validos',
      'Dias máximos deve ser ≥ Dias mínimos vencidos',
      function validarRange(maximo) {
        const minimo = this.parent.diasMinimoVencidos;
        if (maximo == null || minimo == null) return true;
        return Number(maximo) >= Number(minimo);
      }
    ),
  codigosPerfilComprador: Yup.array()
    .of(Yup.number().integer())
    .min(1, 'Selecione ao menos um perfil de comprador'),
  codigoGrupoEmpresa: Yup.number()
    .nullable()
    .integer()
    .test(
      'ge-ou-grupo-ge',
      'Selecione GE ou Grupo de GEs (mutuamente exclusivos)',
      function validarMutuamenteExclusivo(value) {
        const grupoGes = this.parent.codigoGrupoGes;
        if (value == null && grupoGes == null) return true;
        return !(value != null && grupoGes != null);
      }
    ),
  codigoGrupoGes: Yup.number().nullable().integer(),
  codigoCidadeCobranca: Yup.number().nullable().integer(),
  codigoFamilia: Yup.number().nullable().integer(),
  codigoConta: Yup.number().nullable().integer(),
  modoAutomatico: Yup.boolean(),
  incluirChequeDevolvidoAlinea11: Yup.boolean(),
});

export const atribuirCobradorSchema = Yup.object().shape({
  cobradorCodigo: Yup.number()
    .typeError('Selecione um cobrador')
    .required('Selecione um cobrador')
    .integer('Cobrador inválido'),
});
